// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelViewPayors-LoadingHeader_cls1__4VWu-","cls2":"PaymentChannelViewPayors-LoadingHeader_cls2__sJqRD PaymentChannelViewPayors-LoadingHeader_cls1__4VWu-"};